import { isProd } from './config';

export const AWS = {
  REGION: 'us-east-1',
  ACCESS_ID: isProd ? 'AKIAIDNNYI4CSCWS6BAA' : 'AKIAUKO3UN2ZIPWNHBAK',
};

export const FILES_BUCKET = isProd ? 'files.thehiringengine.com' : 'files-dev.thehiringengine.com';
export const RESUMES_BUCKET = 'resumes-expeditiondata-com';
